import * as Fields from './fields';
import * as FormSubmit from './form_submit';
import * as FormHelpers from './helpers';
import * as Steps from './steps';
import * as Widget from '../widgets/base';

export function submit(config) {
  Steps.validate_current_step(config);

  if (Steps.is_current_step_valid(config)) {
    show_loading_container(config);

    try {
      FormSubmit
        .send_event(config)
        .then(data => {
          show_after_submit_container(config);
          console.log("lead submitted!")
        })
        .catch(error => {
          show_form_container(config);

          console.log(error)
        });
    } catch (error) {
      show_form_container(config);

      console.log(error);
    }
  } else {
    // handle form validation
    console.warn("invalid inputs!")
  }
}

function show_form_container(config) {
  const loading_container = Widget.get(config).querySelector('.form-container--loading')
  const form_container = Widget.get(config).querySelector('.form-container--fields')
  const after_submit_container = Widget.get(config).querySelector('.form-container--after-submit')
  form_container.classList.remove('invisible');
  after_submit_container.classList.add('invisible');
  loading_container.classList.add('invisible');
}

function show_after_submit_container(config) {
  const loading_container = Widget.get(config).querySelector('.form-container--loading')
  const form_container = Widget.get(config).querySelector('.form-container--fields')
  const after_submit_container = Widget.get(config).querySelector('.form-container--after-submit')
  form_container.classList.add('invisible');
  after_submit_container.classList.remove('invisible');
  loading_container.classList.add('invisible');
}

function show_loading_container(config) {
  const loading_container = Widget.get(config).querySelector('.form-container--loading')
  const form_container = Widget.get(config).querySelector('.form-container--fields')
  const after_submit_container = Widget.get(config).querySelector('.form-container--after-submit')
  form_container.classList.add('invisible');
  after_submit_container.classList.add('invisible');
  loading_container.classList.remove('invisible');
}

function init_consent_modal(config) {
  const modal_trigger = Widget.get(config).querySelector('[data-disclaimer-modal-trigger]');
  const modal = Widget.get(config).querySelector('[data-disclaimer-modal]');

  if(modal_trigger && modal) {
    const modal_close = Widget.get(config).querySelector('[data-disclaimer-modal-close]');

    modal_trigger.addEventListener('click', event => {
      modal.classList.add('is-active');
    });

    modal_close.addEventListener('click', event => {
      modal.classList.remove('is-active');
    });
  }
}

export function init(config) {
  if (Driftrock.settings.debug) {
    console.info(`[Driftrock] Initialising form: ${config.form.id}`);
  }

  Steps.init_controls(config);

  init_consent_modal(config);

  Fields.init(config);

  if (FormHelpers.wasFormSubmitted(config.form.id, 'widget')) {
    show_after_submit_container(config);
  } else {
    show_form_container(config);
    Steps.show_step(config, config.steps[0]);
  }
}